import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { GenericModalPage } from './generic-modal';

@NgModule({
  declarations: [
    GenericModalPage,
  ],
  imports: [
    IonicPageModule.forChild(GenericModalPage),
  ],
})
export class GenericModalPageModule {}



// WEBPACK FOOTER //
// ./src/pages/generic-modal/generic-modal.module.ts